var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.5V5M15.5 1.5V5M2 9H20M15 12.5H15.01M15 16H15.01M11 12.5H11.01M11 16H11.01M7 12.5H7.01M7 16H7.01M20.5 8V17.5C20.5 20 19 21.5 16.5 21.5H5.5C3 21.5 1.5 20 1.5 17.5V8C1.5 5.5 3 4 5.5 4H16.5C19 4 20.5 5.5 20.5 8Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.f496f78db7a12b28f5b3c4a0a6a1c342.svg";
export { ForwardRef as ReactComponent };